/**
 * useOnlineStatus — tracks browser online/offline state.
 */

import { useSyncExternalStore } from 'react'

function subscribe(callback: () => void) {
  window.addEventListener('online', callback)
  window.addEventListener('offline', callback)
  return () => {
    window.removeEventListener('online', callback)
    window.removeEventListener('offline', callback)
  }
}

function getSnapshot() {
  return navigator.onLine
}

export function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot)
}
